import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";
const style = () => {
    const { space1 } = theme();
    return StyleSheet.create({
        container: {
            flexDirection: "column",
            justifyContent: "flex-start",
        },
        error: {
            marginTop: space1,
        },
    });
};
export { style };
